import {makeISODateString} from '@shared/helpers/date'
import {eq} from '@shared/helpers/lang'

import {DeliveryAttributeCode, DeliveryAttributeCodeType} from '@web/core/constants'
import {isArrivalGuarantee} from '@web/helpers/policies'

const eqQuick = eq(DeliveryAttributeCode.QUICK)
const eqPickup = eq(DeliveryAttributeCode.PICKUP)

/** 예상 출발 시각 결정 */
export const getDepartureDateTime = ({
    deliveryDateTime,
    branchDepartureDate,
    branchDepartureTime,
    deliveryAttributeType,
    salesChannelType,
}: {
    deliveryDateTime?: string
    branchDepartureDate?: string
    branchDepartureTime?: string
    deliveryAttributeType?: Maybe<string>
    salesChannelType: string
}) => {
    // 기존 장보기 배달출발시각
    if (salesChannelType === 'BRANCH' && !(eqQuick(deliveryAttributeType) || eqPickup(deliveryAttributeType))) {
        return makeISODateString({date: branchDepartureDate, time: branchDepartureTime})
    }

    return deliveryDateTime
}

/** 도착 예정 시각 결정. 도착보장과 배송시뮬레이터만 값이 있음. */
export const getEstimatedArrivalTime = ({
    arrivalGuaranteeDateTime,
    predictionDate,
    deliveryAttributeType,
}: {
    arrivalGuaranteeDateTime?: number
    predictionDate?: number
    deliveryAttributeType?: string
}) => {
    if (isArrivalGuarantee(deliveryAttributeType as DeliveryAttributeCodeType) && arrivalGuaranteeDateTime) {
        return new Date(arrivalGuaranteeDateTime).toISOString()
    }

    if (predictionDate) {
        return new Date(predictionDate).toISOString()
    }
}
